export const ProductsActionTypes = {
  REQUEST_GET_PRODUCTS: 'REQUEST_GET_PRODUCTS',
  GET_PRODUCTS_SUCCESS: 'GET_PRODUCTS_SUCCESS',
  GET_PRODUCTS_SET: 'GET_PRODUCTS_SET',
  GET_PRODUCTS_FAILURE: 'GET_PRODUCTS_FAILURE',
  SET_HOME_PAGE: 'SET_HOME_PAGE',
  SET_PRODUCT_VISUALIZED: 'SET_PRODUCT_VISUALIZED',
  SET_PRODUCT_VISUALIZED_FAILURE: 'SET_PRODUCT_VISUALIZED_FAILURE',
  SET_CPANEL_LOADING: 'SET_CPANEL_LOADING',
  GET_CPANEL_LINK: 'GET_CPANEL_LINK',
  GET_PRODUCT_BY_ID: 'GET_PRODUCT_BY_ID',
  SET_ADD_ALERT: 'SET_ADD_ALERT',
  REQUEST_CLEAR_NEW_ALERTS: 'REQUEST_CLEAR_NEW_ALERTS',
  SET_CLEAR_NEW_ALERTS: 'SET_CLEAR_NEW_ALERTS',
  SET_ALERTS_VISIBILITY: 'SET_ALERTS_VISIBILITY',
  GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
  GET_ALL_PRODUCTS_FAILURE: 'GET_ALL_PRODUCTS_FAILURE',
  GET_ALL_PRODUCTS_SUCCESS: 'GET_ALL_PRODUCTS_SUCCESS',
  SET_ALL_PRODUCTS_LIST: 'SET_ALL_PRODUCTS_LIST',
  SET_CONSULTED_PRODUCTS_LIST: 'SET_CONSULTED_PRODUCTS_LIST',
  GET_N8N_REQUEST: 'GET_N8N_REQUEST',
  GET_N8N_SET: 'GET_N8N_SET',
  GET_N8N_LOADING: 'GET_N8N_LOADING',
  GET_N8N_SUCCESS: 'GET_N8N_SUCCESS',
  GET_N8N_FAILURE: 'GET_N8N_FAILURE',
  REQUEST_GET_USER_PRODUCTS: 'REQUEST_GET_USER_PRODUCTS',
  GET_USER_PRODUCTS_SUCCESS: 'GET_USER_PRODUCTS_SUCCESS',
  GET_USER_PRODUCTS_FAILURE: 'GET_USER_PRODUCTS_FAILURE',
  SET_USER_PRODUCTS: 'SET_USER_PRODUCTS',
  SET_LOADING_USER_PRODUCTS: 'SET_LOADING_USER_PRODUCTS',
};
